import React, { Suspense, lazy } from 'react';
import EditionList from './EditionList';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { size, get } from 'global/lib/lodash';
import { Courses } from '../courses';
import { LeftSideBar, GridContainer, ScreenCenterContent } from 'global/components/perform-grid';
import { FilterChips } from 'global/components/filterchips';
import { useScreen } from 'global/styles';
import EditionsFilters from 'feature/document/Filters/EditionsFilters';
import NavToTop from 'feature/nav/NavToTop';
import { sortByDate } from 'global/utils';
import { Text } from 'global/components/text';
import useNavSettings from 'global/hooks/useNavSettings';

const LibraryAiSearch = lazy(() => import(/* webpackChunkName: "library-agent" */ 'feature/document/LibrarySearch'));

const include = ['assessment', 'edition'].join(',');

const EditionListPage = (props) => {
  const { isMobile } = useScreen();
  const { nav } = useNavSettings();
  const courses = useRetrieveData(
    { url: `/course-assignments` },
    {
      build: ['courseAssignments'],
      params: {
        filter: { context: 'my' },
        include,
      },
      transformData: (d) => sortByDate(d, 'updatedAt'),
    }
  );

  const coursereview = useRetrieveData(
    { url: `/course-assignments` },
    {
      build: ['courseAssignments'],
      params: {
        filter: { role: 'reviewer' },
        include,
      },
      transformData: (d) => sortByDate(d, 'updatedAt'),
    }
  );

  const showCourses = get(props, 'showCourses', true) && !courses.loading && !!size(courses.data);
  const showreview = get(props, 'showReview', true) && !coursereview.loading && !!size(coursereview.data);

  return (
    <GridContainer>
      <LeftSideBar hidden={isMobile}>
        <EditionsFilters {...props} display={'editions'} courses={courses} />
      </LeftSideBar>

      <ScreenCenterContent compactTop ignoreRight>
        <NavToTop />
        {isMobile ? <EditionsFilters {...props} display={'editions'} courses={courses} /> : <FilterChips id={'library.editions'} />}
        {showCourses && <Courses {...props} {...courses} />}
        {showreview && <Courses {...coursereview} isReview />}
        {nav.agent ? (
          <Suspense fallback={null}>
            <LibraryAiSearch />
          </Suspense>
        ) : null}
        <Text type="headline_medium" style={{ display: isMobile && !showCourses && !showreview ? 'none' : undefined }}>
          Library Reference
        </Text>
        <EditionList {...props} courses={courses} coursesLoading={courses.loading} />
      </ScreenCenterContent>
    </GridContainer>
  );
};

export default EditionListPage;
